import { render, staticRenderFns } from "./PayrollPeriods.vue?vue&type=template&id=099c11aa"
import script from "./PayrollPeriods.vue?vue&type=script&lang=js"
export * from "./PayrollPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports